import { graphql } from 'gatsby';

import { VideoPlayer } from '../VideoPlayer';

type VideoSectionProps = {
  section: Queries.VideoSectionFragmentFragment;
};

export const VideoSection = ({ section }: VideoSectionProps) => (
  <div className={'video-section'}>
    <VideoPlayer
      source={{
        type: 'video',
        sources: [
          {
            src: section.link!,
            provider: 'youtube',
          },
        ],
      }}
    />
  </div>
);

export const query = graphql`
  fragment VideoSectionFragment on STRAPI__COMPONENT_GENERAL_VIDEO_LINK {
    id
    link
    strapi_component
  }
`;
